import 'svelte';
import { nmMuseCalcStartup } from './startup';
import * as CONST from './const';
/*
if (MobileDetect){
  const MD = new MobileDetect(window.navigator.userAgent);

  function isMobile(): boolean {
      return !!(MD.mobile() || MD.tablet() || MD.phone());
  }
  nmMuseCalcStartup.setMobileDetect(isMobile);
}*/
function InitCalc() {
    //auto initialization of calculator invokers
    //document.addEventListener('DOMContentLoaded', () => {
    const els = document.querySelectorAll(CONST.TRIGGER_SELECTOR);
    if (els && els.length) {
        els.forEach((el) => {
            nmMuseCalcStartup.start(el);
        });
    }
    //});
}
document.addEventListener('DOMContentLoaded', () => {
    InitCalc();
});
